// extracted by mini-css-extract-plugin
export default {"container":"ships-in_container__dl5MW","icon":"ships-in_icon__Me93k"};